import React from "react";
import { Icon } from "@iconify/react";
import qrcodeOutline from "@iconify/icons-ant-design/qrcode-outline";
import mobileOutline from "@iconify/icons-ant-design/mobile-outline";

const lastElement = () => {
  const myUrl = window.location.href;
  const url_array = myUrl.split("/");
  return url_array[url_array.length - 1];
};

class About extends React.Component {
  render() {
    return (
      <section id="about" className="about">
        <div className="about-decor">
          <div className="about-circle1">
            <Icon
              style={{ marginRight: -10 }}
              width={80}
              height={80}
              icon={qrcodeOutline}
            />
            {/* <img src="assets/images/team1.png" alt="team1" /> */}
          </div>
          <div className="about-circle2">
            <Icon
              style={{ marginRight: 30 }}
              width={200}
              height={200}
              icon={mobileOutline}
            />
            {/* <img src="assets/images/main-banner1.png" alt="banner1" /> */}
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="about-contain">
                <div>
                  {lastElement() === "" ? (
                    <h2 className="title">
                      <span>ΓΝΩΡΙΣΤΕ ΤΗΝ ΕΦΑΡΜΟΓΗ</span>
                    </h2>
                  ) : (
                    <h2 className="title">
                      Σχετικα με το <span>QRSTAND</span>
                    </h2>
                  )}
                  <p className="caption-about">
                    Το QRSTAND είναι ένα καινοτόμο application με καταχωρημένα
                    πνευματικά δικαιώματα, που σκοπό έχει την άρτια οργανωμένη
                    ροή της έκθεσης. Η κατάργηση των φυλλαδίων είναι πλέον
                    γεγονός. Η περιήγηση του επισκέπτη γίνεται μοναδική εμπειρία
                    και ο εκθέτης έχει τη δυνατότητα της άμεσης και ουσιαστικής
                    επαφής με τον ενδιαφερόμενο.
                  </p>
                  <div className="row sm-mb">
                    <div className="col-md-6">
                      <ul className="about-style">
                        {/* <li className="abt-hover"> */}
                        <li>
                          <div className="about-icon">
                            {/* <div className="icon-hover">
                              <img
                                src="assets/images/icon1.png"
                                alt="easy-to-customized"
                              />
                            </div> */}
                            <img
                              src="assets/images/qr-stand-logo-icon.png"
                              alt="Awasome-Design"
                            />
                          </div>
                          <div className="about-text">
                            <h3>Δωρεάν για Android και iOS</h3>
                          </div>
                        </li>
                        <li className="removeMargin" style={{ marginTop: 56 }}>
                          <div className="about-icon">
                            {/* <div className="icon-hover">
                              <img
                                src="assets/images/icon3.png"
                                alt="easy-to-use"
                              />
                            </div> */}
                            <img
                              src="assets/images/qr-stand-logo-icon.png"
                              alt="Awasome-Design"
                            />
                          </div>
                          <div className="about-text">
                            <h3>Εύκολη και άμεση χρήση</h3>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="about-style">
                        <li>
                          <div className="about-icon">
                            {/* <div className="icon-hover">
                              <img
                                src="assets/images/icon2.png"
                                alt="Awasome-Design"
                              />
                            </div> */}
                            <img
                              src="assets/images/qr-stand-logo-icon.png"
                              alt="Awasome-Design"
                            />
                          </div>
                          <div className="about-text">
                            <h3>Οργανωμένες πληροφορίες για τους εκθέτες</h3>
                          </div>
                        </li>
                        <li>
                          <div className="about-icon">
                            {/* <div className="icon-hover">
                              <img
                                src="assets/images/icon4.png"
                                alt="SEO-Friendly"
                              />
                            </div> */}
                            <img
                              src="assets/images/qr-stand-logo-icon.png"
                              alt="Awasome-Design"
                            />
                          </div>
                          <div className="about-text">
                            <h3>Άμεση επικοινωνία με τους εκθέτες</h3>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="about-style">
                        <li>
                          <div className="about-icon">
                            {/* <div className="icon-hover">
                              <Icon
                                width={24}
                                height={24}
                                icon={qrcodeOutline}
                              />
                            </div> */}
                            <img
                              src="assets/images/qr-stand-logo-icon.png"
                              alt="Awasome-Design"
                            />
                          </div>
                          <div className="about-text">
                            <h3>Δωρεάν παροχή qrcode για τον εκθέτη.</h3>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="about-style">
                        <li>
                          <div className="about-icon">
                            {/* <div className="icon-hover">
                              <img
                                src="assets/images/icon2.png"
                                alt="Awasome-Design"
                              />
                            </div> */}
                            <img
                              src="assets/images/qr-stand-logo-icon.png"
                              alt="Awasome-Design"
                            />
                          </div>
                          <div className="about-text">
                            <h3>Σάρωση των qrcodes των επισκεπτών.</h3>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <div className="top-margin">
                              <a className="nav-link" href="#feature"><button type="button" className="btn btn-custom theme-color theme-color">ΔΕΙΤΕ ΠΕΡΙΣΣΟΤΕΡΑ</button></a>

                           </div> */}
                  {lastElement() === "" ? (
                    <div>
                      <center>
                        <a href="https://apps.apple.com/app/id1467479271">
                          <img
                            src="assets/images/appstore.png"
                            alt="appstore"
                            className="store"
                          />
                        </a>
                        <a
                          href="https://play.google.com/store/apps/details?id=gr.progressnet.qrstand"
                          style={{ marginLeft: 10 }}
                        >
                          <img
                            className="ml-10 store"
                            src="assets/images/play-store.png"
                            alt="play-store"
                          />
                        </a>
                        <div style={{ marginTop: 15 }}>
                          <a href={`${process.env.PUBLIC_URL}/the-app`}>
                            <button className="btn btn-custom theme-color">
                              ΠΕΡΙΣΣΟΤΕΡΑ
                            </button>
                          </a>
                        </div>
                      </center>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-7 d-medium-none">
              <div className="about-right">
                <div className="about-phone">
                  <img
                    src="assets/images/aboutus.png"
                    className="img-fluid"
                    alt="aboutus"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/about.js